import React, { useState } from 'react';

import {
  getBucketCustomersCoached,
  getExperienceLevels,
} from '../../utils/coach';
import { useCountLines } from '../../utils/hooks/useCountLines';
import { Svg } from '../SvgIcon';
import Qualification from '../common/Qualification';

import CoachGoalSpecificOutcomes from './CoachGoalSpecificOutcomes';
import type {
  CoachCategorySpecificInfoCategoryInfoFragment,
  CoachCategorySpecificInfoCoachFragment,
} from './__generated-gql-types__/CoachCategorySpecificInfo.generated';

interface CoachCategorySpecificInfoProps {
  coach: CoachCategorySpecificInfoCoachFragment;
  categoryInfo: CoachCategorySpecificInfoCategoryInfoFragment;
}

const CoachCategorySpecificInfo: React.FC<CoachCategorySpecificInfoProps> = ({
  coach,
  categoryInfo,
}) => {
  const [qualificationsLines, qualificationsRef] = useCountLines();

  const [expandedQualifications, setExpandedQualifications] = useState(false);

  const bucketedCustomersCoached = categoryInfo.customersCoached
    ? getBucketCustomersCoached(categoryInfo.customersCoached)
    : null;

  return (
    <div className="mt-6">
      {coach.professionalCoach ? (
        <Qualification
          icon={Svg.CERTIFICATE_CHECKMARK}
          text="Coaches professionally"
        />
      ) : null}
      {categoryInfo.experienceLevel &&
      getExperienceLevels(categoryInfo.category.id)[
        categoryInfo.experienceLevel
      ] ? (
        <Qualification
          icon={Svg.EMPLOYEE_BADGE}
          text={`Experience level: ${
            getExperienceLevels(categoryInfo.category.id)[
              categoryInfo.experienceLevel
            ]
          }`}
        />
      ) : null}
      {categoryInfo.testScore ? (
        <Qualification
          icon={Svg.TEST}
          text={`Scored a ${categoryInfo.testScore} on the ${categoryInfo.category.name}`}
        />
      ) : null}
      {bucketedCustomersCoached ? (
        <Qualification
          icon={Svg.PEOPLE}
          text={`${bucketedCustomersCoached} people coached for ${categoryInfo.category.name}`}
        />
      ) : null}
      {coach.openToInternational ? (
        <Qualification
          icon={Svg.EARTH}
          text="Open to working with clients outside the U.S."
        />
      ) : null}
      <CoachGoalSpecificOutcomes
        className="mt-6"
        coach={coach}
        goal={categoryInfo.category.goal}
        categoryId={categoryInfo.category.id}
      />
      {categoryInfo.qualifications ? (
        <div className="mt-6">
          <p
            ref={qualificationsRef}
            className={`whitespace-pre-line text-lg font-normal text-leland-gray-light ${
              !expandedQualifications && qualificationsLines >= 4
                ? 'line-clamp-4'
                : ''
            }`}
          >
            {categoryInfo.qualifications}
          </p>
          {qualificationsLines > 4 ? (
            <button
              className="link link--primary mt-0.5 text-base font-medium"
              onClick={() =>
                setExpandedQualifications((prevState) => !prevState)
              }
              id="coach_category_specific_info--toggle_qualifications"
            >
              {expandedQualifications ? 'View less' : 'View more'}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default CoachCategorySpecificInfo;
